// project imports
import samplePage from './main-page';
import other from './other';
import pages from './pages';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [other]
  //import samplePage, pages and other
};

export default menuItems;
